import { BusStopRow } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopRow";
import { FC } from "react";
import {
  AlternativeTransportItinerary,
  AlternativeTransportItineraryStop,
  VehicleStatus,
} from "shared/types/alternativeTransport";

type Props = {
  itinerary: AlternativeTransportItinerary | null;
  vehicleStatus: VehicleStatus;
};

export const BusStopTableBody: FC<Props> = ({ itinerary, vehicleStatus }) => {
  const allStops: AlternativeTransportItineraryStop[] = (() => {
    if (!itinerary) return [];
    if (itinerary.returnStops !== null && itinerary.returnStops.length > 0) {
      return itinerary.stops.concat(itinerary.returnStops.slice(1));
    }
    return itinerary.stops;
  })();

  if (!allStops.length) {
    return null;
  }

  const lastArrivedIndex = allStops
    .map((stop) => !!stop.actualArrivalTime)
    .lastIndexOf(true);

  return (
    <>
      {allStops.map((stop, index) => (
        <BusStopRow
          // eslint-disable-next-line react/no-array-index-key -- index is required since the same stop can repeat
          key={index}
          stop={stop}
          index={index}
          vehicleStatus={vehicleStatus}
          currentStopIndex={lastArrivedIndex}
        />
      ))}
    </>
  );
};
